import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import {
  OpenInNew as OpenInNewIcon,
  ContentCopy as ContentCopyIcon,
} from '@mui/icons-material';
import { DeleteIcon } from '../shared/Icons';

interface FormRowMenuProps {
  anchor: HTMLElement | null;
  open: boolean;
  viewUrl: string;
  onClose: () => void;
  onCopyLink: () => void;
  onDelete: () => void;
}

export const FormRowMenu: React.FC<FormRowMenuProps> = ({
  anchor,
  open,
  viewUrl,
  onClose,
  onCopyLink,
  onDelete,
}) => (
  <Menu
    className="form-list-menu"
    anchorEl={anchor}
    open={open}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
  >
    <MenuItem
      onClick={() => {

        onClose();
        window.open(viewUrl, '_blank', 'noopener,noreferrer');
      }}
    >
      <OpenInNewIcon />
      Open live form
    </MenuItem>
    <MenuItem onClick={onCopyLink}>
      <ContentCopyIcon />
      Copy link
    </MenuItem>
    <MenuItem sx={{ color: 'var(--admin-danger)' }} onClick={onDelete}>
      <DeleteIcon />
      Delete
    </MenuItem>
  </Menu>
);
